/* eslint-disable react/prop-types */
/* eslint-env browser */
import classnames from 'classnames'
import React from 'react'

import { insertURLParameter } from '../../../../common/client/url-manipulator'
import { useTranslator } from '../TranslatorProvider'

interface BoundariesFullListProps {
  host: string
  hostPath: string
  locale: string
  initialQuery?: string
  description?: string
  boundaries: {
    countryName: string
    deptName: string
    boundaryName: string
    boundaryOsmId: string
    pageUrl: string
  }[]
}

export const BoundariesFullList: React.FC<BoundariesFullListProps> = ({
  boundaries,
  host,
  hostPath,
  initialQuery,
  description,
  locale,
}) => {
  const t = useTranslator(locale)

  const [searchQuery, setSearchQuery] = React.useState(initialQuery || '')
  const onSearchQueryChange: React.ChangeEventHandler<HTMLInputElement> = React.useCallback(e => {
    setSearchQuery(e.target.value)
    insertURLParameter('q', e.target.value)
  }, [])

  const filteredBoundaries = React.useMemo(() => {
    if (searchQuery.trim().length === 0) {
      return boundaries
    }
    return boundaries.filter(elt =>
      `${elt.countryName} ${elt.deptName} ${elt.boundaryName}`
        .toLocaleLowerCase()
        .includes(searchQuery.toLocaleLowerCase().trim())
    )
  }, [searchQuery])

  return (
    <div>
      <div className="columns is-multiline has-padding-horizontal-medium">
        {description && (
          <div className="column is-12">
            <p>{description}</p>
            {/*
            <p>
              <a href="/map">{`${t('hydro.country.searchInput.mapLink')} >`}</a>
            </p>
            */}
          </div>
        )}
        <div className="column is-12">
          <form
            itemProp="potentialAction"
            itemScope
            itemType="http://schema.org/SearchAction"
            action={`${host}${hostPath}`}
            method="GET"
          >
            <div className="field">
              <div className={classnames('control has-icons-left')}>
                <meta itemProp="target" content={`${host}${hostPath}?q={q}`} />
                <input
                  value={searchQuery}
                  onChange={onSearchQueryChange}
                  className="input"
                  type="text"
                  id="q"
                  name="q"
                  placeholder={t('hydro.boundaries.searchInput.placeholder')}
                  itemProp="query-input"
                />
                <span className="icon is-medium is-left">
                  <i className={classnames('has-text-primary fas fa-search')} />
                </span>
              </div>
            </div>
          </form>
        </div>
        <div className="column is-12">
          <ul>
            {filteredBoundaries.map(water => (
              <li key={`${water.countryName}/${water.deptName}/${water.boundaryName}-${water.boundaryOsmId}`}>
                <a
                  href={water.pageUrl}
                  title={`${water.boundaryName} (${water.deptName})`}
                  className="is-size-6"
                  style={{ whiteSpace: 'normal' }}
                >
                  <span>{water.boundaryName}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}
